import React, { useState, useEffect } from 'react';
import './PopupManager.css';
import { ContentApi } from '../../../api/services/content/ContentApi';
import { CATEGORIES } from '../../admin/category/Categories';

const PopupManager = () => {
  const [popupData, setPopupData] = useState({
    [CATEGORIES.NOTICE]: null,
    [CATEGORIES.ISSUE]: null,
    [CATEGORIES.NEWS]: null,
    [CATEGORIES.JOB_POSTING]: null,
    [CATEGORIES.POPUP]: null
  });
  const [showPopups, setShowPopups] = useState({
    [CATEGORIES.NOTICE]: false,
    [CATEGORIES.ISSUE]: false,
    [CATEGORIES.NEWS]: false,
    [CATEGORIES.JOB_POSTING]: false,
    [CATEGORIES.POPUP]: false
  });

  // 쿠키 설정 함수(보류)
  const setCookie = (name, value, days) => {
    try {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value};${expires};path=/`;
      console.log(`쿠키 설정: ${name}=${value}, 만료: ${expires}`);
    } catch (error) {
      console.error("쿠키 설정 오류:", error);
    }
  };

  // 쿠키 확인 함수(보류)
  const getCookie = (name) => {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${name}=`));
    const value = cookieValue ? cookieValue.split('=')[1] : null;
    return value;
  };

  // 팝업 데이터 가져오기
  useEffect(() => {
    const fetchPopupData = async () => {
      try {
        const categories = [CATEGORIES.NOTICE, CATEGORIES.ISSUE, CATEGORIES.NEWS, CATEGORIES.JOB_POSTING, CATEGORIES.POPUP];
        const newPopupData = { ...popupData };
        const newShowPopups = { ...showPopups };

        for (const category of categories) {
          const dontShowCookie = getCookie(`dontShow${category}Popup`);
          
          if (!dontShowCookie) {
            try {
              const data = await ContentApi.getPopupContent(category);
              
              if (data && data.success && data.data) {
                newPopupData[category] = data.data;
                newShowPopups[category] = true;
              }
            } catch (error) {
              console.log(`${category} 팝업 데이터 없음:`, error.message);
            }
          }
        }

        setPopupData(newPopupData);
        setShowPopups(newShowPopups);
      } catch (error) {
        console.error('팝업 데이터 로딩 실패:', error);
      }
    };

    fetchPopupData();
  }, []);

  // 오늘 하루 보지 않기 + 닫기
  const dontShowToday = (category) => {
    setCookie(`dontShow${category}Popup`, 'true', 1);
    setShowPopups(prev => ({ ...prev, [category]: false }));
  };

  // 단순 닫기
  const closePopup = (category) => {
    setShowPopups(prev => ({ ...prev, [category]: false }));
  };

  // 배너형 팝업 이미지 규격 검증 함수
  const validateBannerImageDimensions = (imageUrl) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const { width, height } = img;
        const aspectRatio = width / height;
        
        // 배너형 규격 체크
        const isValidRatio = aspectRatio >= 2.5 && aspectRatio <= 4.5;
        const isValidSize = width >= 800 && width <= 1920 && height >= 200 && height <= 480;
        
        resolve({
          isValid: isValidSize && isValidRatio,
          width,
          height,
          aspectRatio,
          recommendation: !isValidSize || !isValidRatio ? 
            '배너형 팝업 권장 규격: 1200x400px ~ 1600x400px (비율 3:1 ~ 4:1)' : null
        });
      };
      img.onerror = () => resolve({ isValid: false, error: '이미지 로드 실패' });
      img.src = imageUrl;
    });
  };

  // 팝업 컴포넌트
  const SimplePopup = ({ category, data, onClose, onDontShow, show }) => {
    if (!show || !data) {
        return null;
    }
    
    const positionStyle = {
        left: category === CATEGORIES.NOTICE ? '20px' : 
              category === CATEGORIES.ISSUE ? '380px' :
              category === CATEGORIES.NEWS ? '740px' : '1100px',
        top: '40px',
    };
    
    const imageUrl = data?.mainImage;

    return (
      <div 
        className={`popup ${category}-popup`}
        style={{
          ...positionStyle,
          position: 'fixed',
          width: '340px',
          backgroundColor: 'white',
          border: '2px solid #e5e7eb',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
          overflow: 'hidden'
        }}
      >
        <div className="popup-inner" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* 이미지 영역*/}
          <div className="popup-image" style={{ 
            borderBottom: '1px solid #e5e7eb', 
            overflow: 'hidden',
            position: 'relative'
          }}>
            {imageUrl ? (
              <img 
                src={imageUrl} 
                alt={data.title || category} 
                style={{ 
                  width: '100%', 
                  height: '100%', 
                }}
                onError={(e) => { 
                  e.target.style.display = 'none'; 
                  console.error("이미지 로드 실패:", imageUrl); 
                }}
              />
            ) : (
              <div style={{ 
                width: '100%', 
                height: '100%', 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                color: 'white',
                fontSize: '16px',
                fontWeight: '500'
              }}>
                {data.title || '이미지 없음'}
              </div>
            )}
          </div>

          {/* 하단 버튼 영역*/}
          <div className="popup-footer" style={{ 
            padding: '12px 16px', 
            backgroundColor: '#374151', 
            color: 'white', 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center' 
          }}>
            <span 
              onClick={onDontShow}
              style={{ 
                cursor: 'pointer', 
                fontSize: '12px',
                color: '#d1d5db',
                textDecoration: 'underline',
                transition: 'color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#fff'}
              onMouseLeave={(e) => e.target.style.color = '#d1d5db'}
            >
              오늘 하루는 표시하지 않습니다
            </span>
            <button 
              className="popup-close" 
              onClick={onClose}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: 'white', 
                fontSize: '20px', 
                cursor: 'pointer',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '4px',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              ×
            </button>
          </div>
        </div>
      </div>
    );
  };

  const hasActivePopups = Object.values(showPopups).some(show => show);

  return (
    <>
      {hasActivePopups && (
        <div 
          className="popup-overlay" 
          style={{ 
            position: 'fixed', 
            top: 0, 
            left: 0, 
            width: '100%', 
            height: '100%', 
            background: 'rgba(0,0,0,0.3)', 
            zIndex: 9998,
            backdropFilter: 'blur(1px)'
          }}
        />
      )}
      
      {Object.keys(popupData).map(category => (
        <SimplePopup 
          key={category}
          category={category}
          data={popupData[category]}
          onClose={() => closePopup(category)}
          onDontShow={() => dontShowToday(category)}
          show={showPopups[category]}
        />
      ))}
    </>
  );
};

export default PopupManager;